import { AppIdentifiers, unsetToken } from '../store/slices/token-state.slice';
import { getAppStore } from '../store/storeRef';
import PostHogService from '../services/PostHog.service';

export const logout = (
  reason?: 'membership_expired' | 'manual' | 'session_expired',
) => {
  // Store the logout reason in localStorage for the login component to read
  if (reason) {
    localStorage.setItem('logout_reason', reason);
  }

  // Reset PostHog user session
  PostHogService.reset();

  getAppStore().dispatch(unsetToken(AppIdentifiers.App));
};

export const getLogoutReason = (): string | null => {
  return localStorage.getItem('logout_reason');
};

export const clearLogoutReason = () => {
  localStorage.removeItem('logout_reason');
};
